<template>
    <div>
        <HeaderBar/>
        <div class="auth-wrapper auth-v2 bg-white">
            <b-row class="auth-inner m-0">
                <div class="w-100 d-flex flex-column ">
                    <HeaderBar/>
                    <div class="mt-4  bg-white">
                        <!-- Basic Module -->
                        <div class="d-flex justify-content-center align-items-center mb-1 mt-3 ">
                            <div class="title">Manejo</div>
                        </div>
                        <div class="d-flex flex-wrap justify-content-center">
                            <b-row class="ml-1 mr-1">
                                <b-col
                                cols="6"
                                >
                                    <b-card class="text-center" @click="navigateTo('basic-healthweighthealth')">
                                        <b-avatar
                                        class="mb-1"
                                        variant="primary"
                                        size="100"
                                        >
                                        <b-img width="60px" 
                                               src="@/assets/images/ganImage/icons/health.png"
                                        />
                                        </b-avatar>
                                        <div class="truncate">
                                            <h2 class="mb-25 font-weight-bolder small-font-card">
                                                Sanidad
                                            </h2>
                                        </div>
                                    </b-card>
                                </b-col>
                                <b-col
                                cols="6"
                                >
                                    <b-card class="text-center" @click="navigateTo('basic-healthreproductionhome')">
                                        <b-avatar
                                        class="mb-1"
                                        variant="primary"
                                        size="100"
                                        >
                                        <b-img width="60px" 
                                               src="@/assets/images/ganImage/icons/reproduction.png"
                                        />
                                        </b-avatar>
                                        <div class="truncate">
                                            <h2 class="mb-25 font-weight-bolder small-font-card">
                                                Reproducción
                                            </h2>
                                        </div>
                                    </b-card>
                                </b-col>
                                <b-col
                                cols="6"
                                >
                                    <b-card class="text-center" @click="navigateTo('basic-healthmilkproduction')">
                                        <b-avatar
                                        class="mb-1"
                                        variant="primary"
                                        size="100"
                                        >
                                        <b-img width="60px" 
                                               src="@/assets/images/ganImage/icons/milk.png"
                                        />
                                        </b-avatar>
                                        <div class="truncate">
                                            <h2 class="mb-25 font-weight-bolder small-font-card">
                                                Producción de Leche
                                            </h2>
                                        </div>
                                    </b-card>
                                </b-col>
                                <b-col
                                cols="6"
                                >
                                    <b-card class="text-center" @click="navigateTo('basic-healthlivestockhome')">
                                        <b-avatar
                                        class="mb-1"
                                        variant="primary"
                                        size="100"
                                        >
                                        <b-img width="60px" 
                                               src="@/assets/images/ganImage/icons/weigth.png"
                                        />
                                        </b-avatar>
                                        <div class="truncate">
                                            <h2 class="mb-25 font-weight-bolder small-font-card">
                                                Pesaje Corporal
                                            </h2>
                                        </div>
                                    </b-card>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                </div>
                <ControlMenu />
            </b-row>
        </div>
    </div>
</template>

<script>
import { BRow, BCol, BLink, BImg, BForm, BButton, BCard, BAvatar  } from 'bootstrap-vue'
import ControlMenu from '@/components/ControlMenu.vue'
import HeaderBar from '@/components/HeaderBar.vue'
export default {
    components: {
        BRow,
        BCol,
        BLink,
        BImg,
        BForm,
        BButton,
        BCard, 
        BAvatar,
        ControlMenu,
        HeaderBar
    },
    data() {
        return {
                  
        }
    },
    methods:{
        navigateTo(routeName){
            this.$router.push({name:routeName});
        }
    }
}

</script>

<style lang="scss">
.title {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    color: #5E5873;
}
.dataLog {
    font-weight: 500;
    font-size: medium;
    color: #5E8F23;
}
.small-font-card{
    font-size:14px !important;
}
@import '@core/scss/vue/pages/page-auth.scss';
</style>